import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { useNavigate, useLocation } from 'react-router-dom';

interface NavItem {
  to: string;
  label: string;
  icon: string;
  admin?: boolean;
}

const ITEMS: NavItem[] = [
  { to: '/', label: 'Startseite', icon: 'house' },
  { to: '/timesheet', label: 'Zeitplan', icon: 'calendar3' },
  { to: '/team', label: 'Team', icon: 'people' },
  { to: '/time-entries', label: 'Zeiteinträge', icon: 'list-check' },
  { to: '/reports', label: 'Berichte', icon: 'bar-chart' },
  { to: '/vacation', label: 'Urlaub', icon: 'airplane' },
  { to: '/timesheet-admin', label: 'Zeiterfassung-Übersicht', icon: 'clipboard-check', admin: true },
  { to: '/vacation-admin', label: 'Urlaubsverwaltung', icon: 'calendar-check', admin: true },
  { to: '/time-entry-change-requests', label: 'Zeitänderungsanträge', icon: 'pencil-square' },
  { to: '/settings', label: 'Einstellungen', icon: 'gear' },
  { to: '/users', label: 'Nutzerverwaltung', icon: 'person-gear', admin: true },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: RootState) => state.auth.user);
  const isAdmin = user?.role === 'admin';

  return (
    <nav className="sidebar d-flex flex-column flex-shrink-0 p-3">
      <h5 className="sidebar-title mb-3">Menü</h5>
      <ul className="nav flex-column mb-auto">
        {ITEMS.filter((item) => !item.admin || isAdmin).map((item) => {
          const active = location.pathname === item.to;
          return (
            <li className="nav-item mb-1" key={item.to}>
              <button
                className={`btn btn-link sidebar-btn ${active ? 'active' : ''}`}
                onClick={() => navigate(item.to)}
              >
                <i className={`bi bi-${item.icon}`} aria-hidden="true"></i>
                {item.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Sidebar;
